import { render, staticRenderFns } from "./unbindDormTree.vue?vue&type=template&id=24336aaa&"
import script from "./unbindDormTree.vue?vue&type=script&lang=js&"
export * from "./unbindDormTree.vue?vue&type=script&lang=js&"
import style0 from "./unbindDormTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports